// tslint:disable: no-unused-expression
import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges, OnDestroy } from '@angular/core';

import { NormalizeTextPipe } from 'src/app/pipes/normalize-text.pipe';

import { StringValues, AnyValues } from 'src/app/interfaces/undetermined';

@Component({
  templateUrl: './select2.component.html',
  styleUrls: ['./select2.component.scss'],
  selector: 'app-select2',
})
export class Select2Component implements OnChanges, OnDestroy {

  /* element: Listado de opciones a mostrar, matriz de objetos con 1 o 2 propiedades
    Estructura Number: 4 → Generará un array ["1","2","3","4"]
    Estrucutra Objeto: { [prop]: "Texto", [prop2]: "Id" }
    Estrucutra Array: ["Texto", "Id"]
  */
  @Input() element: AnyValues[] | number;
  /* keys: Llaves del objeto proporcionado a element
    Ejemplo Para element Objeto: [{ key: "Id", text: "Texto" }], keys: ['text','key']
    Ejemplo Para element Array: [["Texto", "Id"]], keys: ['0','1']
    Ejemplo Para element Number: 4, keys: ["key"]
  */
  @Input() keys: [string, string] | null;
  // type: Verifica si se deben permitir selección de multiples elementos
  @Input() type = "single";
  // sendValues: Envía listado de las opciones seleccionadas
  @Output() sendValues: EventEmitter<string[]>;
  /* elementList: Guarda el listado de opciones con el formato de materializecss
    Ejemplo Para element: [{ key: "Id", text: "Texto" }], elementList: [{ "Texto (Id)": null }]
  */
  elementList: StringValues;
  // value: Valor para seleccionar
  @Input() value: string;
  // isNumeric: Si está definidio entonces element se tomará como Estructura Number
  @Input() isNumeric: boolean;
  // keySelect: ID único del componente
  keySelect: string;
  // reset: Elimina todos los elementos seleccionados
  @Input() reset;

  constructor() {
    // ↓ Incializa los enventos
    this.sendValues = new EventEmitter();
    // ↓ Crea el ID del componente
    this.keySelect = this.generateHexString(8);
  }

  ngOnChanges(event: SimpleChanges) {
    // ↓ Verifica que se reciban las opciones a mostrar
    if (event.element) {
      // ↓ Inicializa las opciones en formato materialize
      this.elementList = {};
      // ↓ Verifica si la estructura es Number
      if (this.isNumeric) {
        // ↓ Genera el array y asigna la propiedad que se recibiío en keys
        this.element = Array.from({ length: this.element as number }, (e: undefined, i: number) => ({ [this.keys[0]]: i + 1 }));
      }
      // ↓ Agrega imagen a cada elemento de la lista, de acuerdo a sus iniciales
      (this.element as []).forEach((elm: AnyValues) => {
        // ↓ Verifica si la estructura no es Number
        if (!this.isNumeric) {
          // key: Une los valores de las propiedades de element para generar la llave con formato materializecss
          let key = elm[this.keys[1]] ? `${elm[this.keys[0]]} (${elm[this.keys[1]]})` : `${elm[this.keys[0]]}`;
          // ↑ Verifica si la estructura tiene 1 o 2 propiedades para unirlas
          // ↓ Elimina las tildes y similares
          key = new NormalizeTextPipe().transform(key);
          // ↓ Crea el objeto con formato materializecss y asigna una imagen con las iniciales del texto
          this.elementList[key] = 'https://ui-avatars.com/api/?background=e0e0e0&color=373738&name=' + elm[this.keys[0]].slice(0, 20);
        } else { this.elementList[`${elm[this.keys[0]]}`] = null; }
        // ↑ Crea el objeto con formato materializecss sin imagen
      });
      // ↓ Espera a que genere la estructura
      setTimeout(() => {
        // ↓ Inicializa las configuraciones de materializecss
        this.setMaterialize().then(() => {
          // ↓ Verifica si se debe asignar un valor por defecto
          if (this.value) {
            // ↓↓ Agrega el valor al select2
            const chips = M.Chips.getInstance(document.querySelector("#chips-" + this.keySelect));
            chips.addChip({ tag: this.value });
          }
        });
      }, 0);
    }
    // ↓ Verifica si se debe reiniciar el formulario
    if (event.reset) {
      // ↓↓ Verifica que existan chips
      const chips: HTMLElement = document.querySelector("#chips-" + this.keySelect);
      if (chips) {
        // chips: guarda la instancia del select2
        const instance = M.Chips.getInstance(chips);
        // length: Cantidad de elementos seleccionados
        const length = instance ? instance.chipsData.length : 0;
        // ↓ Elimina todos los elementos
        for (let i = 0; i < length; i++) { instance.deleteChip(0); }
      }
    }
    // ↓ Verifica si se debe cambiar el valor por defecto
    if (event.value) {
      // ↓ Verifica que el select2 esté definido
      if (document.querySelector("#chips-" + this.keySelect)) {
        // chips: guarda la instancia del select2
        const chips = M.Chips.getInstance(document.querySelector("#chips-" + this.keySelect));
        setTimeout(() => {
          // ↓ Verifica que solo se pueda seleccionar un valor cuando type es single
          if (this.type === "single" && chips.chipsData.length > 0) { chips.deleteChip(0); }
          // ↓ Agrega el chip
          chips.addChip({ tag: this.value });
          // ↓ Cierra el autocompletado del select2
          (M.Autocomplete.getInstance(document.querySelector("#chips-" + this.keySelect + " .input")) as any).close();
        }, 0);
      }
    }
  }

  // setMaterialize() Inicia materializecss
  setMaterialize = (): Promise<void> => {
    return new Promise((resolve: () => void) => {
      // data: guarda una copia de elementList que puede ser modificada
      const data = { ...this.elementList };
      // Configuración materialize para los chips
      // secondaryPlaceholder, limit: Verifica que valor colocar según var(type),
      // placeholder: verifica que valor colocar según la cantidad de elementos de la lista
      // ↓* Configuraciones materializecss
      const chips: HTMLElement = document.querySelector("#chips-" + this.keySelect);
      M.Chips.init(chips, {
        // ↓↓↓ Establece las opciones dependiendo si se permite selección multiple
        placeholder: (this.element as []).length > 0 ? "Seleccionar" : "No disponible",
        secondaryPlaceholder: this.type !== "single" ? "Agregar" : "\u{26D4}",
        limit: this.type === "single" ? 1 : Infinity,
        autocompleteOptions: {
          minLength: 0,
          limit: 30,
          data,
          // ↓ sortFunction(): Método para ordenar la data
          sortFunction: (prev: any, curr: any) => {
            if (typeof this.element[0][this.keys[0]] === "number") { prev = Number(prev); curr = Number(curr); }
            return prev < curr ? -1 : (prev > curr ? 1 : 0);
          },
        },
        // onChipAdd(): Método para realizar acciones al momento de selcionar una opción
        onChipAdd: (list: Element, elm: Element) => {
          // ↓↓ Verifica si la selección no está definida en las opciones y cancela la selección
          if (data[(elm.childNodes[0] as any).data] === undefined) {
            (elm.querySelector(".material-icons") as HTMLElement).click();
          } else { delete data[(elm.childNodes[0] as any).data]; }
          // ↑ Si la selección está definida, la elimina de las opciones permitidas
          // ↓ Comparte las opciones seleccionadas
          if (document.body.contains(elm)) {
            elm.addEventListener("keyup", (event: KeyboardEvent) =>
              event.key === "Enter" ? (((event.target as HTMLElement).querySelector(".material-icons") as HTMLElement).click()) : null);
          }
          this.shareList(list[0].M_Chips.chipsData);
        },
        // onChipSelect: Método cuando se selecciona un chip
        onChipSelect: (list: Element, elm: Element) => this.type === "single" ? (elm.querySelector(".material-icons") as HTMLElement).click() : null,
        // onChipDelete: método cuando se elimina un chip
        onChipDelete: (list: Element, elm: Element) => {
          // ↓↓ Verifica que la opción a eliminar exista en las opciones completas y las agrega las opciones disponibles
          if (this.elementList[(elm.childNodes[0] as any).data] !== undefined) {
            data[(elm.childNodes[0] as any).data] = this.type === "multiple" ? 'https://ui-avatars.com/api/?background=e0e0e0&color=373738&name=' + ((elm.childNodes[0] as any).data).split("(")[0].slice(0, 20) : null;
          }
          // ↓ Comparte las opciones seleccionadas
          this.shareList(list[0].M_Chips.chipsData);
          // ↓ Verifica si no permite seleccion multiple
          if (this.type === "single") {
            // ↓↓ Abre el menu de opciones
            const input: HTMLInputElement = document.querySelector("#chips-" + this.keySelect + " .input");
            (M.Autocomplete.getInstance(input) as any).open();
          }
        }
      });
      setTimeout(resolve, 0);
    });
  }

  /* shareList(): Método para compartir las opciones seleccionadas al componente padre
    elms: Opciones seleccionadas con formato materializecss
  */
  shareList(elms: { tag: string }[]) { this.sendValues.emit(elms.map((elm: { tag: string }) => elm.tag)); }

  /* generateHexString(): Genera el id único que se utilizará en el select2
    length: Longitud del id
  */
  generateHexString(length: number): string {
    // ret: Guarda el id
    let ret = "";
    // ↓ Añade texto aleatorio
    while (ret.length < length) { ret += Math.random().toString(16).substring(2); }
    // ↓ Devuelve el id con la longitud indicada
    return ret.substring(0, length);
  }

  // ngOnDestroy() Método que se ejecuta cuando se abandona el componente
  ngOnDestroy() {
    // ↓* Destruye las instancias de materializecss
    const chips: HTMLElement = document.querySelector("#chips-" + this.keySelect);
    chips ? (M.Chips.getInstance(chips) ? M.Chips.getInstance(chips).destroy() : null) : null;
  }

}
